import getKeyboardShortcutsOptions from '../store/store';
import { mutatorAction } from 'satcheljs';
import KeyboardShortcutsMode from 'owa-service/lib/contract/KeyboardShortcutsMode';

export default mutatorAction('selectShortcutsOption', function selectShortcutsOption(
    shortcutSet: KeyboardShortcutsMode
) {
    let optionState = getKeyboardShortcutsOptions();
    optionState.shortcuts = shortcutSet;
});
